/* eslint-disable */
import axios from "axios";
import dotenv from "dotenv";
import jwt from "jsonwebtoken";
dotenv.config();

var apiIP = "";
if (process.env.VUE_APP_IP_API) {
  apiIP = `${process.env.VUE_APP_IP_API}${process.env.VUE_APP_PORT_REST ? ":" + process.env.VUE_APP_PORT_REST : ""
    }`;
} else {
  apiIP = "https://app.boxdasorte.com";
}

const getIdEmpresa = () => {
  const decoded = jwt.decode(localStorage.getItem("user-token"));
  if (decoded) {
    return decoded.idEmpresa;
  }
  return null;
};

var idEmpresa = getIdEmpresa() ? getIdEmpresa() : process.env.VUE_APP_WL;

export default {
  getDecoded() {
    const token = localStorage.getItem("user-token");
    if (token) return jwt.decode(token);
  },
  postFile(controller, action, formData) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controller}/${action}`;
        var token = localStorage.getItem("user-token");

        axios
          .post(endpoint, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: token,
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response && error.response.data && error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject("Falha ao enviar arquivo CSV");
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },
  getParams(controllerName, action = "", params = {}) {
    return new Promise((resolve, reject) => {
      try {
        let endpoint = `${apiIP}/${controllerName}/${action}`;
        const token = localStorage.getItem("user-token");

        if (params && Object.keys(params).length > 0) {
          const query = Object.entries(params)
            .map(
              ([key, val]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
            )
            .join("&");
          endpoint += `?${query}`;
        }

        axios
          .get(endpoint, {
            headers: {
              Authorization: token,
            },
          })
          .then((response) => resolve(response))
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.error &&
              error.response.data.error.errorMessage
            ) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject("Erro ao buscar parâmetros");
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },
  getAll(controllerName, extraParams, action = "Listar") {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        if (extraParams)
          if (extraParams.PageNumber != undefined) {
            if (action == "") {
              endpoint = endpoint + "Page/" + extraParams.PageNumber;
            } else {
              endpoint = endpoint + "/" + extraParams.PageNumber;
            }
          }

        endpoint = endpoint
          .replace("idEmpresa=null", "idEmpresa=" + idEmpresa)
          .replace("idEmpresa=undefined", "idEmpresa=" + idEmpresa);

        if (endpoint.includes("?")) {
          endpoint += `&fromAdm=true`;
        } else {
          endpoint += `?fromAdm=true`;
        }

        var token = localStorage.getItem("user-token");
        axios
          .get(endpoint, {
            headers: {
              Authorization: token,
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject("Ação não Encontrada");
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  getOne(controllerName, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}/${extraParams.PrimaryKey}/${extraParams.PageNumber}`;
        console.log(endpoint);
        axios
          .get(endpoint, {
            extraParams,
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  get(controllerName, extraParams = {}) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}`;
        console.log(endpoint);

        if (endpoint.includes("?")) {
          endpoint += `&fromAdm=true`;
        } else {
          endpoint += `?fromAdm=true`;
        }

        axios
          .get(endpoint, { params: extraParams })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  getFilter(controllerName, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}/filter/${extraParams.SearchText}?page=${extraParams.PageNumber}`;

        axios
          .get(endpoint, {
            extraParams,
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject("Ação não Encontrada");
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  post(controllerName, action = "create", data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;

        if (extraParams)
          if (extraParams.PageNumber != undefined) {
            if (action == "") {
              endpoint = endpoint + "Page/" + extraParams.PageNumber;
            } else {
              endpoint = endpoint + "/" + extraParams.PageNumber;
            }
          }
        data.idEmpresa = idEmpresa;

        var token = localStorage.getItem("user-token");

        if (endpoint.includes("?")) {
          endpoint += `&fromAdm=true`;
        } else {
          endpoint += `?fromAdm=true`;
        }

        axios
          .post(endpoint, data, {
            headers: {
              Authorization: token,
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              console.log(error);
              reject(error.response.data.error.errorMessage);
            } else {
              reject("Ação não Encontrada");
            }
          });
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  },

  upload(controllerName, action, data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${idEmpresa}/${action}`;
        axios
          .post(endpoint, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject("Ação não Encontrada");
            }
          });
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  },

  put(controllerName, action = "update", data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        var token = localStorage.getItem("user-token");
        data.idEmpresa = idEmpresa;
        axios
          .put(endpoint, data, {
            headers: {
              Authorization: token,
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject("Ação não Encontrada");
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  delete(controllerName, action = "update", data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;

        data = {
          headers: {
            Authorization: token,
          },
        };
        data.idEmpresa = idEmpresa;
        axios
          .delete(endpoint, data)
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject("Ação não Encontrada");
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  validaToken(token, controllerName, action) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;

        axios
          .post(
            endpoint,
            {
              idEmpresa: idEmpresa,
              front: true,
            },
            {
              headers: {
                Authorization: token,
              },
            }
          )
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            console.log(error);
            resolve({
              data: {
                result: false,
              },
            });
          });
      } catch (e) {
        reject(e);
      }
    });
  },
};
